import { useDraftStore } from '~/stores/draft'
import { useMiscDraftProgressivePromosStore } from '~/stores/miscDraftProgressivePromos'

/**
 * Fetches and checks promotional code related data. **This uses useLazyAsyncData** so always place this above onMounted calls.
 */
export function useProgressivePromosCheck() {
  const { $pinia } = useNuxtApp()
  const { FETCH: FETCH_PROMOS } = useMiscDraftProgressivePromosStore($pinia)
  const { CHECK_FOR_PROGRESSIVE_PROMO } = useDraftStore($pinia)

  return useLazyAsyncData(async () => {
    await FETCH_PROMOS()
  })
}
